import { Typography, Select } from 'mobily-ui-library/lib';
import { RegionList } from '../../data/RegionList';
import './Region.scss';
import { useTranslation } from 'react-i18next';

type RegionProps = {
    title: string
    rtl: boolean
    handleSelect: (value: string) => void;
}

function Region({ title, rtl, handleSelect }: RegionProps) {
    const { t } = useTranslation();

    const regionData = RegionList.map(item => {
        return {
            text: rtl ? item.region_ar : item.region_en,
            id: item.id,
            icon: item.icon
        }
    });

    return (
        <>
            <section className={rtl ? 'Modal__section ModalArabic' : 'Modal__section'}>
                <Typography rtl={rtl} className='Modal__title'>{title}</Typography>
                <Select
                    rtl={rtl}
                    options={regionData}
                    placeholder={t('region')}
                    onChange={handleSelect}
                />
            </section>

        </>
    )
}

export default Region